import { addErrorToReport, loadLanguagePack } from '@americanexpress/one-app-ducks';
import { composeModules } from 'holocron';
import { loadTravelCreditOneCMS } from '../fetchye/travelCreditOneCMSFetchye';

export const loadModuleData = async ({ store: { dispatch } }) => {
  try {
    const resolution = await Promise.allSettled([
      dispatch(loadTravelCreditOneCMS),
      dispatch(loadLanguagePack('axp-travel-credit', { fallbackLocale: 'en-US' })),
      dispatch(composeModules([
        { name: 'axp-travel-advisory' },
        { name: 'axp-travel-multiple-rewards' },
        {
          name: 'axp-travel-search-hotels',
          props: {
            theme: 'blue',
            searchRedirectConfig: { filterFHR: true, filterTHC: true },
          },
        },
        {
          name: 'axp-travel-terms-and-conditions',
          props: {
            programs: ['hotelcredit'],
          },
        },
      ])),
    ]);
    await Promise.all(resolution.filter((result) => result.status === 'rejected')
      .map(async (result) => {
        dispatch(addErrorToReport(result.reason, {
          collectionMethod: 'loadModuleData rejected',
          moduleID: 'axp-travel-credit',
          caught: true,
        }));
      }));
  } catch (e) {
    await dispatch(addErrorToReport(e, {
      collectionMethod: 'loadModuleData error',
      moduleID: 'axp-travel-credit',
      caught: false,
    }));
  }
};
